import { mapGetters } from 'vuex';

// use icongenie cli to generate all images from a single png (requires node version >= 1.22.2 )
// docs
// https://quasar.dev/quasar-cli-vite/developing-pwa/app-icons-pwa

export default {
  computed: {
    ...mapGetters('user', ['label']),
    ...mapGetters('config', ['config']),
  },
  mounted() {
    this.metaInfo();
  },
  methods: {
    createMeta(name, content) {
      const meta = document.createElement('meta');
      meta.name = name;
      meta.content = content;

      document.head.appendChild(meta);
    },
    createLink(options = {}) {
      const filteredOptions = Object.fromEntries(Object.entries(options).filter(([, value]) => value));

      const link = document.createElement('link');
      Object.assign(link, filteredOptions);

      document.head.appendChild(link);
    },
    metaInfo() {
      const themeColor = '#027be3';
      const iconLabel = this.label?.collectivityLabel;
      if (!iconLabel) return;

      const manifestToRemove = document.querySelector('link[rel="manifest"][href="manifest.json"]');
      if (manifestToRemove) manifestToRemove.remove();

      const newManifest = document.createElement('link');
      newManifest.rel = 'manifest';
      newManifest.href = `${this.config.API.BASE_URL}/api/pwa/manifest?label=${iconLabel}`;

      document.head.appendChild(newManifest);

      const tags = {
        meta: [
          { name: 'theme-color', content: themeColor },
          { name: 'mobile-web-app-capable', content: 'yes' },
          { name: 'apple-mobile-web-app-status-bar-style', content: 'default' },
          {
            name: 'msapplication-TileImage',
            content: `statics/whitelabel/icons/${iconLabel}/ms-icon-144x144.png`,
          },
          { name: 'msapplication-TileColor', content: '#000000' },
          { name: 'apple-mobile-web-app-title', content: 'MijnOmgeving' },
        ],

        link: [
          {
            rel: 'icon',
            type: 'image/png',
            sizes: '128x128',
            href: `statics/whitelabel/icons/${iconLabel}/favicon-128x128.png`,
          },
          {
            rel: 'icon',
            type: 'image/png',
            sizes: '96x96',
            href: `statics/whitelabel/icons/${iconLabel}/favicon-96x96.png`,
          },
          {
            rel: 'icon',
            type: 'image/png',
            sizes: '32x32',
            href: `statics/whitelabel/icons/${iconLabel}/favicon-32x32.png`,
          },
          {
            rel: 'icon',
            type: 'image/png',
            sizes: '16x16',
            href: `statics/whitelabel/icons/${iconLabel}/favicon-16x16.png`,
          },
          {
            rel: 'icon',
            type: 'image/ico',
            href: `statics/whitelabel/icons/${iconLabel}/favicon.ico`,
          },

          {
            rel: 'apple-touch-icon',
            sizes: '180x180',
            href: `statics/whitelabel/icons/${iconLabel}/apple-icon-180x180.png`,
          },
          {
            rel: 'apple-touch-icon',
            sizes: '167x167',
            href: `statics/whitelabel/icons/${iconLabel}/apple-icon-167x167.png`,
          },
          {
            rel: 'apple-touch-icon',
            sizes: '152x152',
            href: `statics/whitelabel/icons/${iconLabel}/apple-icon-152x152.png`,
          },
          {
            rel: 'apple-touch-icon',
            href: `statics/whitelabel/icons/${iconLabel}/apple-icon-120x120.png`,
          },

          {
            rel: 'mask-icon',
            href: `statics/whitelabel/icons/${iconLabel}/safari-pinned-tab.svg`,
          },
          {
            rel: 'apple-touch-startup-image',
            media: '(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2)',
            href: `statics/whitelabel/icons/${iconLabel}/apple-launch-828x1792.png`,
          },
          {
            rel: 'apple-touch-startup-image',
            media: '(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3)',
            href: `statics/whitelabel/icons/${iconLabel}/apple-launch-1125x2436.png`,
          },
          {
            rel: 'apple-touch-startup-image',
            media: '(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3)',
            href: `statics/whitelabel/icons/${iconLabel}/apple-launch-1242x2688.png`,
          },
          {
            rel: 'apple-touch-startup-image',
            media: '(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2)',
            href: `statics/whitelabel/icons/${iconLabel}/apple-launch-750x1334.png`,
          },
          {
            rel: 'apple-touch-startup-image',
            media: '(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3)',
            href: `statics/whitelabel/icons/${iconLabel}/apple-launch-1242x2208.png`,
          },
          {
            rel: 'apple-touch-startup-image',
            media: '(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2)',
            href: `statics/whitelabel/icons/${iconLabel}/apple-launch-640x1136.png`,
          },
          {
            rel: 'apple-touch-startup-image',
            media: '(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2)',
            href: `statics/whitelabel/icons/${iconLabel}/apple-launch-1536x2048.png`,
          },
          {
            rel: 'apple-touch-startup-image',
            media: '(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2)',
            href: `statics/whitelabel/icons/${iconLabel}/apple-launch-1668x2224.png`,
          },
          {
            rel: 'apple-touch-startup-image',
            media: '(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2)',
            href: `statics/whitelabel/icons/${iconLabel}/apple-launch-1668x2388.png`,
          },
          {
            rel: 'apple-touch-startup-image',
            media: '(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2)',
            href: `statics/whitelabel/icons/${iconLabel}/apple-launch-2048x2732.png`,
          },
        ],
      };

      tags.meta.forEach((meta) => {
        this.createMeta(meta.name, meta.content);
      });

      tags.link.forEach((link) => {
        this.createLink({ rel: link.rel, type: link.type, media: link.media, sizes: link.sizes, href: link.href });
      });
    },
  },
};
